export function format_money_round (money) {
  if (!money && money != 0) return ''
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(money)
}

export function format_money (money) {
  if (!money && money != 0) return ''
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(money)
}
